import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from './modules/AuthenticationModule';
import { user } from './modules/UserModule';
import { corporationSettingsState } from './modules/CorporationSettingsState';
import { userSessionStateStore } from '@/store/modules/UserSessionStateStore';
import { plannedEventsViewState } from '@/store/modules/PlannedEventsViewStateModule';
import { plannedServiceIndexState } from '@/store/modules/PlannedServiceIndexState';
import { defectReportIndexState } from '@/store/modules/DefectReportIndexState';
import { serviceIndexState } from '@/store/modules/ServiceIndexState';
import { corporationIndexState } from '@/store/modules/CorporationIndexState';
import { serviceRequestIndexState } from '@/store/modules/ServiceRequestIndexState';
import { siteNotificationsViewerState } from '@/store/modules/SiteNotificationsViewerState';
import { siteNotificationIndexState } from '@/store/modules/SiteNotificationIndexState';
import { partOrdersViewState } from '@/store/modules/PartOrdersViewStateModule';


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        uiStatus: {
            //REFACTOR: This thing does fuck all, but plenty of other things to fix so leaving this crap here for now.
            drawerStatus: { selectedIndex: 1 },
            redirectRouteAfterLogin: null,
            redirectUrlAfterLogin: null,
        },
    },

    mutations: {
        setDrawerStatus(state, drawerStatus) {
            state.uiStatus.drawerStatus = drawerStatus;
        },
        setRedirectRouteAfterLogin(state, redirectRouteAfterLogin) {
            state.uiStatus.redirectRouteAfterLogin = redirectRouteAfterLogin;
        },
        setRedirectUrlAfterLogin(state, redirectUrlAfterLogin) {
            state.uiStatus.redirectUrlAfterLogin = redirectUrlAfterLogin;
        },
    },

    modules: {
        auth,
        user,
        corporationSettingsState,
        userSessionStateStore,
        plannedEventsViewState,
        plannedServiceIndexState,
        defectReportIndexState,
        serviceIndexState,
        corporationIndexState,
        serviceRequestIndexState,
        siteNotificationsViewerState,
        siteNotificationIndexState,
        partOrdersViewState,
    },
});
